import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const getPartnerCouponReport = ({ startDate = "", endDate = "", id = "" } = {}) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const params = new URLSearchParams();

  if (startDate && endDate) {
    params.set("startDate", startDate);
    params.set("endDate", endDate);
  }

  if (id) {
    params.set("id", id);
  }

  const query = params.toString();
  const URL = query
    ? `${routes.GET_PARTNER_COUPON_REPORT}?${query}`
    : routes.GET_PARTNER_COUPON_REPORT;

  return new Promise((resolve, reject) => {
    axios
      .get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getPartnerCouponReport;
